//** paths */
import { pageName } from 'src/config/pageInfo/pageNames.js';
import { PATH_CONTACT_CENTER_SUB, PATH_CONTACT_CENTER_NAVIGATION } from 'src/routes/paths';
//** Schemas */
// import { schemaPaymentDetails } from 'src/schema/paymentPaymentDetailsSchema.js';
// import { schemaPolicyOutcome } from 'src/schema/policyOutcomeSchema.js';
// import { schemaSaveAndEmailCC } from 'src/schema/preQualValidationSchema';
// import { schemaGettingStartedCC, schemaSaveAndEmailCC } from 'src/schema/preQualValidationSchema';
import { schemaOpeningScript } from 'src/schema/preQualValidationSchema';

import { Application } from '../const/enums';

//** Page Order */
import {
  contactCenterOpeningScriptFieldNames,
  contactCenterGettingStartedFieldNames,
  contactCenterSaveAndEmailFieldNames,
} from './pageFieldName';
import { pageOrderCC } from './pageOrder';
//** Field Names */
//** What 'stage' of the application is a particular page associated with. */
const stages = {
  PREQUAL: 'PreQualification',
  UNDERWRITING: 'UnderWriting',
  NEWBUSINESS: 'NewBusiness',
  PAYMENT: 'Payment',
};
import { sharedPages } from './sharedPages';

//* ----------------------------------------------------------------

//** The page(s) information - Controls the render and the flow */
export const contactCenterPages = () => {
  let pageDetails = sharedPages(Application.CONTACT_CENTER, 'personOne');
  return [
    {
      index: pageOrderCC.SCRIPT,
      title: 'Opening Script',
      identifier: pageName.CC_OPENING_SCRIPT,
      stage: stages.PREQUAL,
      routePath: PATH_CONTACT_CENTER_SUB.openingScript,
      nextRoutePath: PATH_CONTACT_CENTER_NAVIGATION.personal,
      previousRoutePath: PATH_CONTACT_CENTER_NAVIGATION.openingScript,
      fieldNames: contactCenterOpeningScriptFieldNames(),
      showProgressBar: false,
      activeStep: null,
      schema: schemaOpeningScript(),
      dualSchema: schemaOpeningScript(),
      valid: false, // Set to true when the next page is clicked
      allowNavigation: true,
    },
    {
      index: pageOrderCC.GETTING_STARTED,
      title: 'Getting Started',
      identifier: pageName.GETTING_STARTED,
      stage: stages.PREQUAL,
      routePath: PATH_CONTACT_CENTER_SUB.gettingStarted,
      nextRoutePath: PATH_CONTACT_CENTER_SUB.cover,
      previousRoutePath: PATH_CONTACT_CENTER_SUB.gettingStarted,
      fieldNames: contactCenterGettingStartedFieldNames('personOne'),
      showProgressBar: true,
      activeStep: 0,
      schema: null,
      // schema: schemaGettingStartedCC(),
      dualSchema: null,
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrderCC.SAVE_AND_EMAIL,
      title: 'Save and Email',
      identifier: pageName.SAVE_AND_EMAIL,
      stage: stages.PREQUAL,
      routePath: PATH_CONTACT_CENTER_SUB.saveAndEmail,
      nextRoutePath: PATH_CONTACT_CENTER_NAVIGATION.cover,
      previousRoutePath: PATH_CONTACT_CENTER_NAVIGATION.quote,
      fieldNames: contactCenterSaveAndEmailFieldNames('personOne'),
      showProgressBar: true,
      activeStep: 3,
      schema: null,
      // schema: schemaSaveAndEmailCC(),
      dualSchema: null,
      valid: false,
      allowNavigation: true,
    },
    {
      index: pageOrderCC.PP_CC_PAYMENT,
      title: 'Payment Details',
      identifier: pageName.PP_CC_PAYMENT,
      stage: stages.PAYMENT,
      routePath: PATH_CONTACT_CENTER_SUB.ppCCPayment,
      nextRoutePath: PATH_CONTACT_CENTER_NAVIGATION.ppConfirmation,
      previousRoutePath: PATH_CONTACT_CENTER_NAVIGATION.ppContact,
      fieldNames: null,
      showProgressBar: true,
      activeStep: 6,
      schema: null,
      // schema: schemaPaymentDetails(),
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: true,
    },
    {
      index: pageOrderCC.PP_CC_POLICY_OUTCOME,
      title: 'Policy Outcome',
      identifier: pageName.PP_CC_POLICY_OUTCOME,
      stage: stages.NEWBUSINESS,
      routePath: PATH_CONTACT_CENTER_SUB.ppCCPolicyOutcome,
      nextRoutePath: null,
      previousRoutePath: PATH_CONTACT_CENTER_SUB.ppConfirmation,
      fieldNames: null,
      showProgressBar: true,
      activeStep: 5,
      schema: null,
      // schema: schemaPolicyOutcome('personOne', Application.CONTACT_CENTER),
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: true,
    },
    {
      index: pageOrderCC.PP_CC_UPGRADE_SAVE_CONFIRMATION,
      title: 'Save Confirmation',
      identifier: pageName.PP_CC_UPGRADE_SAVE_CONFIRMATION,
      stage: stages.PAYMENT,
      routePath: PATH_CONTACT_CENTER_SUB.ppCCPolicyOutcome,
      nextRoutePath: null,
      previousRoutePath: PATH_CONTACT_CENTER_SUB.ppCCPolicyOutcome,
      fieldNames: null,
      showProgressBar: true,
      activeStep: 4,
      schema: null,
      // schema: schemaPolicyOutcome('personOne', Application.CONTACT_CENTER),
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
      allowNavigation: true,
    },
    ...pageDetails,
  ];
};
